export default {
  'Teklif Formu': 'טופס הצעת מחיר',
  'Kayıtlı Teklifler': 'הצעות שמורות',
  'Kullanıcı Adı': 'שם משתמש',
  'Şifre': 'סיסמה',
  'Giriş Yap': 'התחבר',
  'Çıkış Yap': 'התנתק',
  'KDV Oranı': 'שיעור מע"מ',
  'Teklif Durumu': 'סטטוס הצעה',
  'Kaydet': 'שמור',
  'PDF Önizleme': 'תצוגה מקדימה PDF',
  'PDF\'ye Aktar': 'ייצוא ל-PDF',
  'E-posta ile Gönder': 'שלח בדוא"ל',
  'Alıcı': 'נמען',
  'Tarih': 'תאריך',
  'Genel Toplam': 'סך הכל',
  'Not': 'הערה',
  'KDV': 'מע"מ',
  'Alt Toplam': 'סכום ביניים',
  'Açıklama': 'תיאור',
  'Ürün Adı': 'שם מוצר',
  'SUT Kodu': 'קוד SUT',
  'Birim Alış Fiyatı': 'מחיר יחידה',
  'Sipariş Adedi': 'כמות הזמנה',
  'Promosyon Ürün': 'מוצר קידום מכירות',
  'Toplam Adet': 'כמות כוללת',
  'Sipariş Tutarı': 'סכום הזמנה',
  'Durum': 'סטטוס',
  'Kabul Edildi': 'אושר',
  'Reddedildi': 'נדחה',
  'Gönderildi': 'נשלח',
  'Taslak': 'טיוטה',
  'Yurtiçi': 'פנימי',
  'Yurtdışı': 'בינלאומי',
  'Sipariş Oluştur': 'צור הזמנה',
  'Ürün Sıralaması': 'מיון מוצרים',
  'Ürünler popülerlik ve önem düzeyine göre sıralanmıştır': 'מוצרים ממוינים לפי פופולריות וחשיבות',
  'Kardiyoloji ve damar cerrahisi ürünleri öncelikli olarak gösterilmektedir': 'מוצרי קרדיולוגיה וכירורגיה וסקולרית מוצגים כעדיפות',
  'Ürün adı, açıklama veya barkod ile ara...': 'חיפוש לפי שם מוצר, תיאור או ברקוד...',
  'Tüm Kategoriler': 'כל הקטגוריות',
  'Kutu görünüm': 'תצוגת רשת',
  'Liste görünüm': 'תצוגת רשימה',
  'Aradığınız kriterlere uygun ürün bulunamadı': 'לא נמצאו מוצרים התואמים לקריטריונים שלך',
  'Ürün Adı Yok': 'אין שם מוצר',
  'Kategori Yok': 'אין קטגוריה',
  'Açıklama yok': 'אין תיאור',
  'Firma Bilgilerini Doldurun': 'מלא פרטי חברה',
  'Sepete Ekle': 'הוסף לעגלה',
  'Firma Bilgileri': 'פרטי חברה',
  'Ülke Seçimi': 'בחירת מדינה',
  'Türkiye': 'טורקיה',
  'Almanya': 'גרמניה',
  'ABD': 'ארה"ב',
  'Firma Ünvanı': 'שם חברה',
  'Vergi Dairesi': 'משרד מס הכנסה',
  'Vergi Numarası': 'מספר מס',
  'Adres': 'כתובת',
  'Şehir': 'עיר',
  'Yetkili': 'אדם מורשה',
  'Telefon': 'טלפון',
  'Email': 'דוא"ל',
  'Bilgileri İlet': 'שלח מידע',
  'Lütfen eksik alanları doldurun': 'אנא מלא את השדות החסרים',
  'Firma kaydedilemedi': 'החברה לא נשמרה',
  'Firma bilgileri başarıyla iletildi': 'פרטי החברה נשלחו בהצלחה',
  'Firma Ünvanı:': 'שם חברה:',
  'Yetkili Kişi:': 'אדם מורשה:',
  'Sepetiniz': 'העגלה שלך',
  'Sepetiniz boş': 'העגלה שלך ריקה',
  'adet': 'יח',
  'Düzenle': 'ערוך',
  'Kaldır': 'הסר',
  'Siparişi Tamamla': 'השלם הזמנה',
  'Lütfen önce firma bilgilerinizi eksiksiz iletin': 'אנא שלח תחילה את פרטי החברה המלאים שלך',
  'Sipariş başarıyla kaydedildi': 'ההזמנה נשמרה בהצלחה',
  'Email adresinize hoş geldiniz mesajı ve erişim linki gönderildi': 'הודעת ברוכים הבאים וקישור גישה נשלחו לדוא"ל שלך',
  'Link 3 gün geçerlidir': 'הקישור תקף ל-3 ימים',
  'Sipariş kaydedilemedi': 'ההזמנה לא נשמרה',
  'Firma Bilgileri Gerekli': 'נדרשים פרטי חברה',
  'Sepete eklemek için önce firma bilgilerinizi doldurun': 'מלא תחילה את פרטי החברה להוספה לעגלה',
  'Önce Bilgileri Doldurun': 'מלא תחילה את המידע',
  'Uyarı': 'אזהרה',
  'Sepete eklemek için önce firma bilgilerinizi doldurmanız gerekmektedir': 'עליך למלא תחילה את פרטי החברה להוספה לעגלה',
  'SUT Kütüphanesi Tanımı': 'הגדרת ספריית SUT',
  'SUT Kodu:': 'קוד SUT:',
  'Standart': 'סטנדרט',
  'Açıklama (isteğe bağlı)': 'תיאור (אופציונלי)',
  'Partner Ol': 'הפוך לשותף',
  'Partner başvuru popup açılacak': 'חלון קופץ של בקשת שותף ייפתח',
  'Dil': 'שפה',
  'E-posta': 'דוא"ל',
  'Şifre': 'סיסמה',
  'Şifremi Unuttum': 'שכחתי סיסמה',
  'Giriş yapılıyor...': 'מתחבר...',
  'E-posta veya şifre hatalı': 'דוא"ל או סיסמה שגויים',
  'Şifre sıfırlama e-postası gönderildi': 'דוא"ל איפוס סיסמה נשלח',
  'E-posta gönderilemedi': 'הדוא"ל לא נשלח',
  'Üye Ol': 'הירשם',
  'Üye Değil Misiniz?': 'אינך חבר?',
  'Şimdi Üye Ol': 'הירשם עכשיו',
  'Misafir Kullanıcı': 'משתמש אורח',
  'Hızlı Sipariş': 'הזמנה מהירה',
  'Misafir Olarak Sipariş Verin': 'הזמן כאורח',
  'Giriş yapmadan hızlıca ürünlerinizi seçin ve siparişinizi oluşturun': 'בחר במהירות את המוצרים שלך וצור את ההזמנה שלך ללא התחברות',
  'Giriş yapmadan sipariş oluşturun': 'צור הזמנה ללא התחברות',
  'Anında Erişim': 'גישה מיידית',
  'Tüm ürünlere anında erişim': 'גישה מיידית לכל המוצרים',
  'Güvenli İşlem': 'עסקה מאובטחת',
  'SSL korumalı güvenli sipariş': 'הזמנה מאובטחת מוגנת ב-SSL',
  'Misafir Olarak Sipariş Oluştur': 'צור הזמנה כאורח',
  'İpucu:': 'טיפ:',
  'Daha fazla özellik için üye olun': 'הירשם לתכונות נוספות',
  'Ücretsiz': 'חינם',
  'Hızlı': 'מהיר',
  'Güvenli': 'מאובטח',
  'bayilikSozlesme': 'קראתי ואני מקבל את תנאי השותפות של INVAMED.',
  'geri': 'חזור',
  'basvuruGonder': 'שלח בקשה',
  'ileri': 'הבא',
  'sozlesmeGonderildi': 'החוזה נשלח לדוא"ל שלך!',
  'sozlesmeDesc': 'אנא העלה את חוזה השותפות INVAMED והמסמכים הנדרשים שנשלחו לדוא"ל שלך למטה.',
  'tamamla': 'השלם בקשה',
  'basvuruAlindi': 'הבקשה שלך התקבלה!',
  'basvuruAlindiDesc': 'צוות INVAMED יבחן את הבקשה שלך ויצור איתך קשר בהקדם האפשרי.',
  'Başvuru Durumu': 'סטטוס בקשה',
  'Başvurunuz onay sürecindedir': 'הבקשה שלך נבדקת',
  'sifreSifirla': 'איפוס סיסמה',
  'sifreSifirlaDesc': 'הזן את הדוא"ל הרשום שלך ונשלח לך הוראות לאיפוס הסיסמה.',
  'gonder': 'שלח',
  'talimatGonderildi': 'הוראות נשלחו',
  'sentDesc': 'הוראות איפוס הסיסמה נשלחו ל-<b>{email}</b>. אנא בדוק את הדוא"ל שלך.',
  'helpTitle': 'איך אני יכול להתחבר?',
  'helpList': [
    'כדי להתחבר לפאנל המפיץ INVAMED, הזן את הדוא"ל הרשום והסיסמה שלך.',
    'כדי להתחבר עם משתמש דמו:',
    'אם שכחת את הסיסמה שלך, השתמש בקישור "שכחתי סיסמה" לבקשת איפוס.',
    'אם יש לך בעיות התחברות, ודא שהדוא"ל והסיסמה שלך נכונים. אם הבעיה נמשכת, צור קשר עם צוות התמיכה שלנו.'
  ],
  'partnerlikSozlesmeTitle': 'חוזה שותפות INVAMED ותנאים',
  'partnerlikSozlesmeText': `1. הוראות כלליות

חוזה זה נכרת בין INVAMED (להלן "החברה") ומועמד שותף (להלן "השותף") למטרות שיתוף פעולה במכירת מכשירים וציוד רפואי.

2. תנאי שותפות

2.1. השותף חייב להיות בעל סמכות משפטית למכירת מכשירים רפואיים.
2.2. השותף חייב להיות ארגון הפועל בתחום הבריאות.
2.3. השותף חייב להיות בעל הרישיונות והתעודות הנדרשים.
2.4. השותף חייב להיות אמין כלכלית.

3. התחייבויות הצדדים

התחייבויות החברה:
3.1. לספק מוצרים ושירותים באיכות גבוהה
3.2. לספק תמיכה טכנית
3.3. לספק הכשרה ומידע
3.4. שקיפות במחירים

התחייבויות השותף:
3.1. לשמור מוצרים בתנאים מתאימים
3.2. לספק שירות לקוחות באיכות גבוהה
3.3. לעמוד בתקנות משפטיות
3.4. להגן על המותג של החברה

4. קביעת מחירים ותשלום

4.1. המחירים נקבעים על ידי החברה
4.2. השותף מחויב לשמור על המחירים שנקבעו
4.3. תנאי התשלום נקבעים בנפרד
4.4. עמלות עשויות להשתנות בהתאם לביצועים

5. סודיות ואבטחה

5.1. הצדדים מחויבים להגן על המידע הסודי של כל אחד מהם
5.2. מידע על לקוחות חייב להישמר בסודיות
5.3. יש לעמוד בסטנדרטים של אבטחת מידע

6. משך החוזה וסיום

6.1. חוזה זה תקף למשך שנה אחת
6.2. ניתן להאריך אותו בהסכמה הדדית
6.3. ניתן לסיים אותו בהודעה מוקדמת של 30 ימים
6.4. ניתן לסיים אותו מיד במקרה של הפרה חמורה

7. פתרון מחלוקות

7.1. מחלוקות מנסות להיפתר בעיקר באמצעות משא ומתן
7.2. בתי המשפט של הרפובליקה של טורקיה מוסמכים למקרים שלא נפתרו

8. תוקף

חוזה זה נקרא, הובן ונקלט על ידי הצדדים.`,
  'partnerlikSozlesmeOnay': 'קראתי, הבנתי ומקבל את חוזה השותפות INVAMED והתנאים לעיל. אני מצהיר שאני מקבל את כל הסעיפים של חוזה זה ואקיים את התחייבויותיי.',
  'sozlesmeyiGoruntule': 'הצג חוזה',
  'sozlesmeyiKapat': 'סגור',
  'Ürün': 'מוצר',
  'Ürün eklemek için ürün listesinden seçim yapın': 'בחר מרשימת המוצרים להוספה לעגלה',
  'Etiketler': 'תגיות',
  'Öncelikli': 'עדיפות',
  'Kapat': 'סגור',
  'globalPartnersTitle': 'שיתוף פעולה עם 30,000 שותפים ברחבי העולם',
  'globalPartnersDesc': 'הרשת הגלובלית הנרחבת שלנו של 30,000 שותפים מניעה חדשנות משותפת, חילופי ידע והצלחה הדדית. בעבודה יחד, אנו מרחיבים ללא הרף את גבולות הטיפול בחולים.',
  'Yardım': 'עזרה',
  'dil': 'שפה',
  'Connect Free!': 'התחבר בחינם!',
  'En çok tercih edilen ürünlerimizi keşfedin': 'גלה את המוצרים הפופולריים ביותר שלנו',
  'Tüm Kategoriler': 'כל הקטגוריות',
  '48 ürün gösteriliyor (Toplam: 8000+)': '48 מוצרים מוצגים (סה"כ: 8000+)',
  'Tüm Ürünleri Gör →': 'צפה בכל המוצרים →',
  'Detaylar': 'פרטים',
  'Sipariş Ver': 'הזמן עכשיו',
  'Giriş Yap': 'התחבר',
  'Hesabınıza giriş yapın': 'התחבר לחשבון שלך',
  'This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.': 'אתר זה מוגן על ידי reCAPTCHA ומדיניות הפרטיות של Google ותנאי השירות חלים.',
  'Ürün Kataloğumuz': 'קטלוג המוצרים שלנו',
  '8000+ ürün çeşitliliği ile hizmetinizdeyiz': 'אנו מציעים יותר מ-8000 מוצרים',
  '1,3B': '1.3K',
  'Partner': 'שותף',
  '8,4M': '8.4M',
  'Toplam Üretim': 'ייצור כולל',
  '23': '23',
  'Branş': 'סניף',
  '27,5B': '27.5K',
  'Toplam Sipariş': 'הזמנות כוללות',
  'Connect Now': 'התחבר עכשיו',
  'Tüm bilgilere tek bir yerden erişebilmek için ücretsiz kaydolun.': 'הירשם בחינם כדי לגשת לכל המידע במקום אחד.',
  'Ürün Detayları': 'פרטי מוצר',
  'Kapat': 'סגור',
  'Yükleniyor...': 'טוען...',
  'Hata': 'שגיאה',
  '{{count}} ürün gösteriliyor (Toplam: 8000+)': '{{count}} מוצרים מוצגים (סה"כ: 8000+)',
  'Şehir Seçimi': 'בחירת עיר',
  'Firma / Sağlık Profesyoneli': 'חברה / איש מקצוע בתחום הבריאות',
  'Yetkili Kişi': 'אדם מורשה',
  'Telefon': 'טלפון',
  'E-posta': 'אימייל',
  'Temel Bilgiler': 'מידע בסיסי',
  'Ek Bilgiler': 'מידע נוסף',
  'Faaliyet Alanı / Sektör': 'תחום פעילות / מגזר',
  'Ülke Seçimi': 'בחירת מדינה',
  'Ülke adı veya kodu ara...': 'חיפוש שם או קוד מדינה...',
  'region.Avrupa': 'אירופה',
  'region.Amerika': 'אמריקה',
  'region.Asya': 'אסיה',
  'region.Afrika': 'אפריקה',
  'region.Okyanusya': 'אוקיאניה',
  'region.Diğer': 'אחר',
  'country.TR': 'טורקיה',
  'country.US': 'ארצות הברית',
  'country.DE': 'גרמניה',
  'country.FR': 'צרפת',
  'country.GB': 'בריטניה',
  'country.IT': 'איטליה',
  'country.ES': 'ספרד',
  'country.RU': 'רוסיה',
  'country.CN': 'סין',
  'country.JP': 'יפן',
  'country.KR': 'קוריאה הדרומית',
  'country.IN': 'הודו',
  'country.BR': 'ברזיל',
  'country.CA': 'קנדה',
  'country.AU': 'אוסטרליה',
  'Ticaret Sicil No': 'מספר רישום מסחרי',
};
